module.exports = __webpack_public_path__ + "images/8a66bbc169eb305d3ed8f840f848dd68ebfcfdc11086358f20f724c7b401c318.svg";